export enum CoreExtensionNames {
  MENTION = "mention",
  UTILITY = "utility",
  CHARACTERCOUNT = "characterCount",
  PARAGRAPH = "paragraph",
  LIST_ITEM = "listItem",
  BULLET_LIST = "bulletList",
  ORDERED_LIST = "orderedList",
  IMAGE = "image"
}
